module.exports = __webpack_public_path__ + "static/media/gem.b3f1203c.gif";